import React from 'react';

const PageHeaderLang = ({ lang = 'FR' }) => {

  lang = lang.toLowerCase();

  console.log("LANG ===>", lang);

  return (
<header id="masthead" className="header-main">
  <div id="header-wrap" className="header-layout1 fixed-height is-sticky">
    <div id="header-main" className="header-main">
      <div className="container">
        <div className="row">

          <div style={{"width":"100%","zIndex":"100"}} dangerouslySetInnerHTML={{ __html: window.getBannerHTML ? window.getBannerHTML({ lang, logoURL: 'https://www.lyra.dental' }) : '' }}></div>

          <div className="header-navigation-container"  dangerouslySetInnerHTML={{ __html: window.getLowerMenu ? window.getLowerMenu({ lang }) : '' }}></div>
          
          <div className="header-btn-phone">
            <a href="tel:330176420060"><i className="fa fa-phone" /><span>+33(0) 1 76 42 00 60</span></a>
          </div>
          <div className="menu-mobile-overlay" />
        </div>
      </div>
      <div id="main-menu-mobile">
        <span className="btn-nav-mobile open-menu">
          <span />
        </span>
      </div>
    </div>
  </div>
</header>

 );
}

export default function PageHeader({ lang = 'EN' }) {
  return PageHeaderLang({ lang })
}